// 使用简单的Base64编码
export const encryptUid = async (uid: string): Promise<string> => {
  try {
    console.log('开始编码UID:', uid);
    // 使用简单的Base64编码
    const encoded = btoa(uid);
    console.log('编码完成，结果:', encoded);
    return encoded;
  } catch (error) {
    console.error('编码失败:', error);
    throw new Error('编码失败');
  }
};

// 解密函数
export const decryptUid = async (encoded: string): Promise<string> => {
  try {
    console.log('开始解码UID:', encoded);
    // 使用简单的Base64解码
    const decoded = atob(encoded);
    console.log('解码完成，结果:', decoded);
    return decoded;
  } catch (error) {
    console.error('解码失败:', error);
    throw new Error('解码失败');
  }
}; 